import type { CardStyleProps } from './types';

const DEFAULT_SHADOWS = {
  sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
  md: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
};

export const getCardBaseStyles = (styleProps?: CardStyleProps): string => {
  if (!styleProps) return '';

  const {
    padding,
    radius,
    background,
    height,
    boxShadow,
    border,
    borderTop,
    borderBottom,
    borderLeft,
    borderRight,
  } = styleProps;

  return `
    ${padding ? `padding: ${padding};` : ''}
    ${radius ? `border-radius: ${radius};` : ''}
    ${background ? `background: ${background};` : ''}
    ${height ? `height: ${height};` : ''}
    ${boxShadow ? `box-shadow: ${boxShadow};` : ''}
    ${(() => {
      if (border === undefined) return '';
      return border ? `border: ${border};` : 'border: none;';
    })()}
    ${borderTop ? `border-top: ${borderTop};` : ''}
    ${borderBottom ? `border-bottom: ${borderBottom};` : ''}
    ${borderLeft ? `border-left: ${borderLeft};` : ''}
    ${borderRight ? `border-right: ${borderRight};` : ''}
  `;
};

export const getCardClickableStyles = (clickable: boolean, styleProps?: CardStyleProps): string => {
  if (!clickable) return '';

  const { hoverBackgroundColor, hoverBorderColor, hoverBoxShadow, activeBoxShadow } =
    styleProps ?? {};

  return `
    cursor: pointer;

    &:hover {
      transform: translateY(-1px);
      background-color: ${hoverBackgroundColor ?? 'inherit'};
      border-color: ${hoverBorderColor ?? 'inherit'};
      box-shadow: ${hoverBoxShadow ?? DEFAULT_SHADOWS.sm};
    }

    &:active {
      transform: translateY(0);
      box-shadow: ${activeBoxShadow ?? DEFAULT_SHADOWS.md};
    }
  `;
};

export const getCardCenterStyles = (center: boolean): string => {
  if (!center) return '';

  return `
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  `;
};

export const getCardStickyStyles = (sticky: boolean, styleProps?: CardStyleProps): string => {
  if (!sticky) return '';

  const { stickyTop = '0' } = styleProps ?? {};

  return `
    position: sticky;
    top: ${stickyTop};
    z-index: 10;
  `;
};